// TODO: Should we import from the tokens folder instead? so that values are synced
const SCREEN_CLASSES = ['xs', 'sm', 'md', 'lg', 'xl'];
/**
 * Map of Screen Classes to their max-pixel-widths
 */
const SCREEN_CLASS_MAX_WIDTHS = {
  xs: 767,
  sm: 1023,
  md: 1439,
  lg: 1919,
  xl: Infinity
};
/**
 * Map of Screen Classes to their min-pixel-widths
 */
const SCREEN_CLASS_MIN_WIDTHS = {
  xs: 0,
  sm: 768,
  md: 1024,
  lg: 1440,
  xl: 1920
};
/**
 * Returns the Screen Class corresponding to the given width
 *
 * @param windowWidth - the width (in px) of the window/screen
 */
function getScreenClass(windowWidth) {
  for (const screenClass of screenClasses) {
    const maxWidth = screenClassMaxWidths[screenClass];
    const minWidth = screenClassMinWidths[screenClass];
    if (windowWidth >= minWidth && windowWidth <= maxWidth) {
      return screenClass;
    }
  }
  // the loop above should be guaranteed to return a value
  // if we hit this error, we messed up
  throw new Error('Misconfigured screen classes.');
}
/**
 * Below are Legacy names and should be avoided in use,
 * as they don't follow any particular naming or casing convention
 */
const screenClasses = SCREEN_CLASSES;
const screenClassMaxWidths = SCREEN_CLASS_MAX_WIDTHS;
const screenClassMinWidths = SCREEN_CLASS_MIN_WIDTHS;
export { SCREEN_CLASSES, SCREEN_CLASS_MAX_WIDTHS, SCREEN_CLASS_MIN_WIDTHS, getScreenClass, screenClassMaxWidths, screenClassMinWidths, screenClasses };